import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CommonMuiTable, { Table } from "../../Component/Table/Table";

import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";

const TeamSize = () => {


  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState("");

  const [loading, setLoading] = useState(false);

  const { kv, set } = useStoreKv();
  const teamSize = kv.teamsize || [];

  const location = useLocation();
  const { clientId } = location.state || {};
  // console.log("Received ID:", clientId);

  const [owners, setOwners] = useState(teamSize);


  const getList = async () => {
    if (!clientId) return;

    try {
      // setLoading(true);
      const res = await get(`${URLS.CLIENT}/team-list/${clientId}`);
      // console.log("team-list client: ", res);

      if (res?.status === "success") {
        const list = res?.data || [];


        const totalTeamSize = list.reduce((sum, item) => sum + (item.team_size || 0), 0);

        setOwners(list);
        set("teamsize", list);
        setTotalCount(totalTeamSize);

        // console.log("Total members:", totalCount);
        // console.log("Total team size:", totalTeamSize);
      } else {
        setOwners([]);
        set("teamsize", []);
      }
    } catch (err) {
      console.error("Error fetching team list:", err);
    } finally {
      // setLoading(false);
    }
  };


  useEffect(() => {
    getList();
  }, [clientId]);



  const columns = React.useMemo(
    () => [
      {
        id: "client_id",
        Header: () => (
          <div className="text-center">
            Client <br /> ID
          </div>
        ),
        accessor: "client_id",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Mobile No",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        id: "",
        Header: () => (
          <div className="text-center">
            Team <br /> Size
          </div>
        ),
        accessor: "team_size",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
    ],
    []
  );

  return (
    <div className="dashRightView d-flex ac-jb flex-column marginScrolls">
      <CustomScroll >
        <div className="container_overalls" style={{ position: 'relative' }}>
          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={owners}
            show={false}
            loading={loading}
          />

        </div>
      </CustomScroll>
      <div className="d-flex ac-jb px-3 team_size">
        <p style={{ color: 'white' }} className="f4 fs-xs-13 fs-sm-14 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20  black">
          Total Team Size
        </p>
        <p style={{ color: 'white' }} className="f4 fs-xs-13 fs-sm-10 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20  black">
          {owners.length}
        </p>
      </div>
    </div>
  );
};

export default TeamSize;
